import { render, staticRenderFns } from "./PrescriptionCountsByGroup.vue?vue&type=template&id=6ca1666b"
import script from "./PrescriptionCountsByGroup.vue?vue&type=script&lang=js"
export * from "./PrescriptionCountsByGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports